import { MinusIcon, PlusIcon } from "@heroicons/react/24/outline";

interface BuyButtonProps {
  quantity: number;
  setQuantity: (quantity: number) => void;
}

export default function BuyButton({ quantity, setQuantity }: BuyButtonProps) {
  function handleDecrease() {
    setQuantity(Math.max(1, quantity - 1));
  }

  function handleIncrease() {
    setQuantity(quantity + 1);
  }

  return (
    <div className="xflex xflex-col xgap-4 xw-full">
      <div className="xflex xflex-row xgap-4 xitems-stretch">
        {/* Quantity Selector */}
        <div
          className="
            xflex xflex-row xitems-center xjustify-between
            xgrow-0 xshrink-0 xbasis-48 md:xbasis-56
            xborder-4 xborder-light-green xborder-solid
            xrounded-[2rem]
            xgap-2
            xpx-4
          "
        >
          <button
            className="
              xflex xitems-center xjustify-center
              xw-8 xh-8
              xbg-transparent
              xborder-none
              xoutline-none
              xappearance-none
              xcursor-pointer
              hover:xopacity-70
              disabled:xopacity-50 disabled:xcursor-not-allowed
            "
            onClick={handleDecrease}
            disabled={quantity <= 1}
            type="button"
            aria-label="Decrease quantity"
          >
            <MinusIcon className="xw-full xh-full" />
          </button>

          <div
            className="
              xfont-grotesque xfont-semibold
              xtext-3xl md:xtext-4xl
              xtext-center
              xw-full xgrow-1
              xflex xitems-center xjustify-center
              xpy-2
            "
          >
            {quantity}
          </div>

          <button
            className="
              xflex xitems-center xjustify-center
              xw-8 xh-8
              xbg-transparent
              xborder-none
              xoutline-none
              xappearance-none
              xcursor-pointer
              hover:xopacity-70
            "
            onClick={handleIncrease}
            type="button"
            aria-label="Increase quantity"
          >
            <PlusIcon className="xw-full xh-full" />
          </button>
        </div>

        {/* Add to Cart Button */}
        <div className="xgrow">
          <button
            type="submit"
            name="add"
            className="
              xbtn xbtn-primary xbtn-lg
              xw-full xh-full
            "
          >
            <span className="xtext-2xl md:xtext-3xl">Add to cart</span>
          </button>
        </div>
      </div>
    </div>
  );
}
